// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { botanixTestnet as _botanixTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the botanixTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 3636
 * Chain Name: Botanix Testnet
 * Default Block Explorer: https://blockscout.botanixlabs.dev
 * Default RPC URL: https://poa-node.botanixlabs.dev
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { botanixTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: botanixTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const botanixTestnet = createCommon({
	..._botanixTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
